import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import i18n from './utils/i18n';
import App from './containers/App/App';
import theme from './styles/theme';
import { BASENAME } from './utils/constants/general';
import store from './redux/store';

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement);

root.render(
	<ThemeProvider theme={theme}>
		{/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
		<CssBaseline />
		<Provider store={store}>
			<BrowserRouter basename={BASENAME}>
				<I18nextProvider i18n={i18n}>
					<App />
				</I18nextProvider>
			</BrowserRouter>
		</Provider>
	</ThemeProvider>
);
